import { create } from "zustand";

export type Theme = "day" | "night";
const KEY = "sw-theme";

function readTheme(): Theme {
  try {
    const stored = localStorage.getItem(KEY);
    if (stored === "night" || stored === "day") return stored;
  } catch {
    /* ignore */
  }
  return "day";
}

function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme);
  document.documentElement.style.colorScheme = theme === "night" ? "dark" : "light";
}

export const useTheme = create<{ theme: Theme; toggle: () => void; setTheme: (t: Theme) => void }>((set, get) => ({
  theme: "day",
  setTheme: (theme) => {
    applyTheme(theme);
    try {
      localStorage.setItem(KEY, theme);
    } catch {
      /* ignore */
    }
    set({ theme });
  },
  toggle: () => get().setTheme(get().theme === "night" ? "day" : "night"),
}));

export function initTheme(): Theme {
  const theme = readTheme();
  applyTheme(theme);
  useTheme.setState({ theme });
  return theme;
}
